import { HttpClient } from '@angular/common/http';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../env.service";
export class UserService {
    constructor(http, envService) {
        this.http = http;
        this.httpOptions = {};
        this.apiURL = '';
        this.apiURL = envService.API_URL;
    }
    saveUser(token, type, options) {
        if (options) {
            let scopes = '';
            const opts = Object.assign({}, options);
            if (opts.scope && opts.scope.length) {
                scopes = '?';
                const optScopes = opts.scope;
                optScopes.forEach((queryParameter) => {
                    scopes += queryParameter + '=1&';
                });
            }
            let apiUrl = '';
            let reqPayload = {};
            if (type === 'google') {
                apiUrl = this.apiURL + 'login_google';
                reqPayload = { 'id_token': token };
            }
            else {
                apiUrl = this.apiURL + 'login_facebook';
                reqPayload = { 'fb_access_token': token };
            }
            return this.http.post(apiUrl, reqPayload, { withCredentials: true });
        }
    }
    getWeavyAccessToken() {
        return this.http.get(this.apiURL + 'user/weavy/accesstoken', { withCredentials: true });
    }
}
UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EnvService)); }, token: UserService, providedIn: "root" });
